import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common.service';

const API_URL = CommonServices.getApiUrl() + 'stock/';

class MealStockService {

  getStockLevels() {
    return axios.get(API_URL, { headers: authHeader() });
  }

  getStockDetail(mealId) {
    return axios.get(API_URL + mealId, { headers: authHeader() });
  }

  saveAdjustment(adjustment) {
    if (adjustment.id) {
      return axios.put(API_URL + 'adjustment/' + adjustment.id, adjustment,
        { headers: authHeader() });
    }
    return axios.post(API_URL + 'adjustment', adjustment, { headers: authHeader() });
  }

  deleteAdjustment(id) {
    return axios.delete(API_URL + 'adjustment/' + id, { headers: authHeader() });
  }

  reconcile(mealId, target) {
    return axios.post(API_URL + 'reconcile', { mealId, target }, { headers: authHeader() });
  }
}

export default new MealStockService();
